import React  from 'react';
import './Other.css';

const Posters = function(props) {

  var data_pubs = [
    {
      img: "img/posters/paovis_poster.png",
      title: "Hypenet: Visualizing Dynamic Hypergraphs",
      authors: "Valdivia, P., Buono, P., & Fekete, J. D.",
      booktitle: "Eurovis",
      year: "2017",
      pdf: "files/Hypenet_EuroVis17.pdf",
      link: "https://hal.inria.fr/hal-01658087/"
    },{
      img: "img/posters/DeciSCM_teaser.png",
      title: "DCPAIRS: A Pairs Plot Based Decision Support System.",
      authors: "Dimara, E., Valdivia, P., & Kinkeldey, C.",
      booktitle: "Eurovis",
      year: "2017",
      pdf: "files/DcPairs_EuroVis17.pdf",
      link: "https://hal.inria.fr/hal-01516470/"
    },
  ];

  var publications = data_pubs.map((pub, i) => {
    return(
      <span key={i}>
          <dl className="publication">
            <dt className="figure">
              {pub.img && <img alt={pub.title} src={pub.img} /> }
            </dt>
            <dd className="ref">
              <span className="ptitle"> {pub.title} </span>
              <span className="authors"> {pub.authors} </span>
              <span className="booktitle"> {pub.booktitle}, </span>
              {pub.pages && <span className="pages"> {pub.pages}, </span>}
              <span className="year"> {pub.year}.</span>
              {pub.pdf && <span className="document"> <a href={pub.pdf}> <img alt="pdf" src="img/pdf.png" className="icon" /> </a> </span>}
              {pub.link && <span className="document"> <a href={pub.link}> <img alt="link" src="img/link.png" className="icon" /> </a></span>}
              {pub.demo && <span className="document"> <a href={pub.demo}> live demo </a> </span>}
              {pub.git && <span className="document"> <a href={pub.git}> <img alt="pdf" src="img/github.png" className="icon" /> </a> </span>}
            </dd>
          </dl>
          <div className="space"></div>
        </span>
    );
  });

  return (
    <div  id="other" className="other">

      <div className="space"></div>
      <h2>
        POSTERS
      </h2>
      <div className="space"></div>

      {publications}

      <div className="space-lg"></div>

    </div>

  );
}

export default Posters;



// WEBPACK FOOTER //
// ./src/Posters.js